import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';

const DISCLAIMER_VERSION = 1;
const STORAGE_KEY = 'odapto_disclaimer_ack';

function getAck() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch { return null; }
}

function setAck(version) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify({ version, timestamp: new Date().toISOString() }));
}

export default function DisclaimerModal() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const ack = getAck();
    if (!ack || ack.version < DISCLAIMER_VERSION) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const handleAccept = () => {
    setAck(DISCLAIMER_VERSION);
    setVisible(false);
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" data-testid="disclaimer-modal">
      <div className="w-full max-w-lg rounded-2xl border border-border bg-card shadow-2xl overflow-hidden animate-in fade-in zoom-in-95 duration-200">
        <div className="p-6 sm:p-8">
          <h2 className="text-lg sm:text-xl font-bold mb-4">A Note Before You Start</h2>

          <div className="space-y-3 text-sm text-muted-foreground leading-relaxed">
            <p>
              Odapto is still under development and available for testing.
            </p>
            <p>
              We help you think better — we don&apos;t predict the future. Our insights and recommendations are there to challenge and support your thinking, not replace your judgment.
            </p>
            <p>
              You decide what to act on and remain responsible for your decisions. Outcomes cannot be guaranteed; business is influenced by factors that neither you nor Odapto may know or foresee.
            </p>
          </div>

          <Button
            onClick={handleAccept}
            className="w-full mt-6 bg-odapto-orange hover:bg-odapto-orange-hover text-white"
            data-testid="disclaimer-accept-btn"
          >
            Got it
          </Button>
        </div>
      </div>
    </div>
  );
}
